import React, { useState, useEffect } from 'react'
import "../css/ImageInput.css"

const ImageInput = ({onChange=undefined, filename=undefined, accept="image/*", prefix=undefined, defaultImage=undefined}) => {
    const [selectedFile, setSelectedFile] = useState()
    const [preview, setPreview] = useState()

    // create a preview as a side effect, whenever selected file is changed
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])

    const onSelectFile = (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined)
            return
        } else {
            setSelectedFile(e.target.files[0])
            if(onChange){
                onChange(e)
            }
        }
    }

    return (
        <div className={`ImageInput-container ${prefix&&`${prefix}-ImageInput-container`}`}>
            { /*  <img src={preview?preview:defaultImage} className={`ImageInput-image ${prefix&&`${prefix}-ImageInput-image`}`} />  */}
            <label 
                htmlFor='ImageInput' 
                className={`ImageInput-image ${prefix&&`${prefix}-ImageInput-image`}`} 
                style={{backgroundImage: `url(${preview?preview:defaultImage})`}}
            />
            <input 
                id='ImageInput'
                type='file' 
                onChange={onSelectFile}
                filename={filename?filename:selectedFile}
                accept={accept}
                className={`ImageInput-input ${prefix&&`${prefix}-ImageInput-input`}`}
                
            />
        </div>
    )
}

export default ImageInput